module.exports = __webpack_public_path__ + "img/2025-03-14-01-02.7ec730a9.png";